export const registry = {
  "1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369": {
    "id": "1ae92b26df02f0abca6304df07debccd18262fdf5fe82daa81593582dac9a369",
    "name": "Rainbow",
    "homepage": "https://rainbow.me/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/rainbow-ethereum-wallet/id1457119021",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "rainbow:",
      "universal": "https://rnbwapp.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Rainbow",
      "colors": {
        "primary": "rgb(0, 30, 89)",
        "secondary": ""
      }
    }
  },
  "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0": {
    "id": "4622a2b2d6af1c9844944291e5e7351a6aa24cd7b23099efac1b2fd875da31a0",
    "name": "Trust Wallet",
    "homepage": "https://trustwallet.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/apple-store/id1288339409",
      "android": "https://play.google.com/store/apps/details?id=com.wallet.crypto.trustapp",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "trust:",
      "universal": "https://link.trustwallet.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Trust",
      "colors": {
        "primary": "rgb(51, 117, 187)",
        "secondary": ""
      }
    }
  },
  "cf21952a9bc8108bf13b12c92443751e2cc388d27008be4201b92bbc6d83dd46": {
    "id": "cf21952a9bc8108bf13b12c92443751e2cc388d27008be4201b92bbc6d83dd46",
    "name": "Argent",
    "homepage": "https://argent.xyz/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/argent/id1358741926",
      "android": "https://play.google.com/store/apps/details?id=im.argent.contractwalletclient",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "argent://app",
      "universal": "https://argent.link/app"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Argent",
      "colors": {
        "primary": "rgb(255, 135, 91)",
        "secondary": ""
      }
    }
  },
  "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96": {
    "id": "c57ca95b47569778a828d19178114f4db188b89b763c899ba0be274e97267d96",
    "name": "MetaMask",
    "homepage": "https://metamask.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/metamask/id1438144202",
      "android": "https://play.google.com/store/apps/details?id=io.metamask",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "metamask:",
      "universal": "https://metamask.app.link"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "MetaMask",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "a5cfbd9a263c9dcfb59d6e9dc00933c46f00277ed78a6a0a1e38b0c17e09671f": {
    "id": "a5cfbd9a263c9dcfb59d6e9dc00933c46f00277ed78a6a0a1e38b0c17e09671f",
    "name": "Gnosis Safe Multisig",
    "homepage": "https://gnosis-safe.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "https://gnosis-safe.io/app/",
      "ios": "https://apps.apple.com/app/id1515759131",
      "android": "https://play.google.com/store/apps/details?id=io.gnosis.safe",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "gnosissafe:",
      "universal": "https://gnosis-safe.io/"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Gnosis Safe",
      "colors": {
        "primary": "#091828",
        "secondary": "#fff"
      }
    }
  },
  "f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46697d": {
    "id": "f2436c67184f158d1beda5df53298ee84abfc367581e4505134b5bcf5f46697d",
    "name": "Crypto.com | DeFi Wallet",
    "homepage": "https://crypto.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/id1262148500",
      "android": "https://play.google.com/store/apps/details?id=co.mona.android",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "cryptowallet:",
      "universal": "https://wallet.crypto.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Crypto.com",
      "colors": {
        "primary": "rgb(17, 153, 250)",
        "secondary": ""
      }
    }
  },
  "0b58bf037bf943e934706796fb017d59eace1dadcbc1d9fe24d9b46629e5985c": {
    "id": "0b58bf037bf943e934706796fb017d59eace1dadcbc1d9fe24d9b46629e5985c",
    "name": "Pillar",
    "homepage": "https://pillarproject.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/apple-store/id1346582238",
      "android": "https://play.google.com/store/apps/details?id=com.pillarproject.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "pillarwallet:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Pillar",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "9d373b43ad4d2cf190fb1a774ec964a1addf406d6fd24af94ab7596e58c291b2": {
    "id": "9d373b43ad4d2cf190fb1a774ec964a1addf406d6fd24af94ab7596e58c291b2",
    "name": "imToken",
    "homepage": "https://token.im/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/us/app/imtoken2/id1384798940",
      "android": "https://play.google.com/store/apps/details?id=im.token.app",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "imtokenv2:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "imToken",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "dceb063851b1833cbb209e3717a0a0b06bf3fb500fe9db8cd3a553e4b1d02137": {
    "id": "dceb063851b1833cbb209e3717a0a0b06bf3fb500fe9db8cd3a553e4b1d02137",
    "name": "ONTO",
    "homepage": "https://onto.app/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/onto-an-ontology-dapp/id1436009823",
      "android": "https://play.google.com/store/apps/details?id=com.github.ontio.onto",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "ontoprovider:",
      "universal": "https://onto.app"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "ONTO",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "20459438007b75f4f4acb98bf29aa3b800550309646d375da5fd4aac6c2a2c66": {
    "id": "20459438007b75f4f4acb98bf29aa3b800550309646d375da5fd4aac6c2a2c66",
    "name": "TokenPocket",
    "homepage": "https://tokenpocket.pro/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/tokenpocket-trusted-wallet/id1436028697",
      "android": "https://play.google.com/store/apps/details?id=vip.mytokenpocket",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "tpoutside:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "TokenPocket",
      "colors": {
        "primary": "rgb(41, 128, 254)",
        "secondary": ""
      }
    }
  },
  "7674bb4e353bf52886768a3ddc2a4562ce2f4191c80831291218ebd90f5f5e26": {
    "id": "7674bb4e353bf52886768a3ddc2a4562ce2f4191c80831291218ebd90f5f5e26",
    "name": "MathWallet",
    "homepage": "https://mathwallet.org/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/math-wallet-blockchain-wallet/id1383637331",
      "android": "https://play.google.com/store/apps/details?id=com.medishares.android",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "mathwallet:",
      "universal": "https://www.mathwallet.org"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "MathWallet",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "ccb714920401f7d008dbe11281ae70e3a4bfb621763b187b9e4a3ce1ab8faa3b": {
    "id": "ccb714920401f7d008dbe11281ae70e3a4bfb621763b187b9e4a3ce1ab8faa3b",
    "name": "BitPay",
    "homepage": "https://bitpay.com",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/bitpay-buy-crypto/id1149581638",
      "android": "https://play.google.com/store/apps/details?id=com.bitpay.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "bitpay:",
      "universal": "https://link.bitpay.com/wallet"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "BitPay",
      "colors": {
        "primary": "rgb(26, 59, 139)",
        "secondary": ""
      }
    }
  },
  "4ab2542c2799c825a8465ba5ab8aa7def52b7904f38b74484af917ed9c0fc4e5": {
    "id": "4ab2542c2799c825a8465ba5ab8aa7def52b7904f38b74484af917ed9c0fc4e5",
    "name": "Ledger Live",
    "homepage": "https://www.ledger.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/app/id1361671700",
      "android": "https://play.google.com/store/apps/details?id=com.ledger.live",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "ledgerlive:",
      "universal": ""
    },
    "desktop": {
      "native": "ledgerlive:",
      "universal": ""
    },
    "metadata": {
      "shortName": "Ledger",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "83f26999937cbc2e2014655796da4b05f77c1de9413a0ee6d0c6178ebcfc3168": {
    "id": "83f26999937cbc2e2014655796da4b05f77c1de9413a0ee6d0c6178ebcfc3168",
    "name": "WallETH",
    "homepage": "https://walleth.org/",
    "chains": [
      "eip155:1",
      "eip155:100",
      "eip155:3",
      "eip155:4",
      "eip155:5",
      "eip155:10",
      "eip155:77"
    ],
    "app": {
      "browser": "",
      "ios": "",
      "android": "https://play.google.com/store/apps/details?id=org.walleth",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "WallETH",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "71dad538ba02a9b321041d388f9c1efe14e0d1915a2ea80a90405d2f6b67a33d": {
    "id": "71dad538ba02a9b321041d388f9c1efe14e0d1915a2ea80a90405d2f6b67a33d",
    "name": "Authereum",
    "homepage": "https://authereum.org",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "https://authereum.com/i/account",
      "ios": "",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Authereum",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "9dab7bd72148e2f796452630230666daf507935fae7bb9baf22b3c11960b034f": {
    "id": "9dab7bd72148e2f796452630230666daf507935fae7bb9baf22b3c11960b034f",
    "name": "Dharma",
    "homepage": "https://www.dharma.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/dharma-save-send-globally/id1495144415",
      "android": "https://play.google.com/store/apps/details?id=io.dharma.Dharma",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "dharma:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Dharma",
      "colors": {
        "primary": "#0DD675",
        "secondary": "#F5F5F5"
      }
    }
  },
  "09102e7bbbd3f92001eda104abe23803181629f695e8f1b95af96d88ff7d5890": {
    "id": "09102e7bbbd3f92001eda104abe23803181629f695e8f1b95af96d88ff7d5890",
    "name": "1inch Wallet",
    "homepage": "https://1inch.io/wallet/",
    "chains": [
      "eip155:1",
      "eip155:56"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/1inch-defi-wallet/id1546049391",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "1inch:",
      "universal": "https://wallet.1inch.io"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "1inch",
      "colors": {
        "primary": "rgb(31, 36, 46)",
        "secondary": ""
      }
    }
  },
  "bae74827272509a6d63ea25514d9c68ad235c14e45e183518c7ded4572a1b0c4": {
    "id": "bae74827272509a6d63ea25514d9c68ad235c14e45e183518c7ded4572a1b0c4",
    "name": "Huobi Wallet",
    "homepage": "https://huobiwallet.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/id1433883012",
      "android": "https://play.google.com/store/apps/details?id=com.huobionchainwallet.gp",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "huobiwallet:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Huobi",
      "colors": {
        "primary": "rgb(45,101,248)",
        "secondary": ""
      }
    }
  },
  "efba9ae0a9e0fdd9e3e055ddf3c8e75f294babb8aea3499456eff27f771fda61": {
    "id": "efba9ae0a9e0fdd9e3e055ddf3c8e75f294babb8aea3499456eff27f771fda61",
    "name": "Eidoo",
    "homepage": "https://eidoo.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/app/apple-store/id1279896253",
      "android": "https://play.google.com/store/apps/details?id=io.eidoo.wallet.prodnet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "eidoo:",
      "universal": "https://eidoo.io/crypto-wallet"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Eidoo",
      "colors": {
        "primary": "rgb(55, 179, 159)",
        "secondary": ""
      }
    }
  },
  "61f6e716826ae8455ad16abc5ec31e4fd5d6d2675f0ce2dee3336335431f720e": {
    "id": "61f6e716826ae8455ad16abc5ec31e4fd5d6d2675f0ce2dee3336335431f720e",
    "name": "MYKEY",
    "homepage": "https://mykey.org",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/app/id1458318224",
      "android": "https://play.google.com/store/apps/details?id=com.mykey.id",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "mykeywalletconnect:",
      "universal": "https://mykey.org"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "MYKEY",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "dcf291a025ead3e94ef694fa75617568daf76bf1e525bb240ecf5bf1add53756": {
    "id": "dcf291a025ead3e94ef694fa75617568daf76bf1e525bb240ecf5bf1add53756",
    "name": "Loopring Wallet",
    "homepage": "https://loopring.io",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/loopring-smart-wallet/id1550921126",
      "android": "https://play.google.com/store/apps/details?id=loopring.defi.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Loopring",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "6bb4596640ce9f8c02fbaa83e3685425455a0917d025608b4abc53bfe55887c6": {
    "id": "6bb4596640ce9f8c02fbaa83e3685425455a0917d025608b4abc53bfe55887c6",
    "name": "TrustVault",
    "homepage": "https://trustology.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/apple-store/id1455959680",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "TrustVault",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "185850e869e40f4e6c59b5b3f60b7e63a72e88b09e2a43a40b1fd0f237e49e9a": {
    "id": "185850e869e40f4e6c59b5b3f60b7e63a72e88b09e2a43a40b1fd0f237e49e9a",
    "name": "Atomic",
    "homepage": "https://atomicwallet.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/atomic-wallet/id1478257827",
      "android": "https://play.google.com/store/apps/details?id=io.atomicwallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Atomic",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "b021913ba555948a1c81eb3d89b372be46f8354e926679de648e4fa2938bed3e": {
    "id": "b021913ba555948a1c81eb3d89b372be46f8354e926679de648e4fa2938bed3e",
    "name": "Coin98",
    "homepage": "https://coin98.app/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://ios.coin98.app/",
      "android": "https://play.google.com/store/apps/details?id=coin98.crypto.finance.media",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "coin98:",
      "universal": "https://coin98.app"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Coin98",
      "colors": {
        "primary": "rgb(39,39,39)",
        "secondary": ""
      }
    }
  },
  "1f69170bf7a9bdcf89403ec012659b7124e158f925cdd4a2be49274c24cf5e5d": {
    "id": "1f69170bf7a9bdcf89403ec012659b7124e158f925cdd4a2be49274c24cf5e5d",
    "name": "CoolWallet S",
    "homepage": "https://coolwallet.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/us/app/coolwallet-s-2018/id1328764142",
      "android": "https://play.google.com/store/apps/details?id=com.coolbitx.cwsapp",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "CoolWallet S",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "beea4e71c2ffbb48b59b21e33fb0049ef6522585aa9c8a33a97d3e1c81f16693": {
    "id": "beea4e71c2ffbb48b59b21e33fb0049ef6522585aa9c8a33a97d3e1c81f16693",
    "name": "Alice",
    "homepage": "https://alicedapp.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/au/app/alice-browser/id1472818028",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Alice",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "138f51c8d00ac7b9ac9d8dc75344d096a7dfe370a568aa167eabc0a21830ed98": {
    "id": "138f51c8d00ac7b9ac9d8dc75344d096a7dfe370a568aa167eabc0a21830ed98",
    "name": "AlphaWallet",
    "homepage": "https://alphawallet.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/alphawallet-eth-wallet/id1358230430",
      "android": "https://play.google.com/store/apps/details?id=io.stormbird.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": "https://aw.app"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "AlphaWallet",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "468b4ab3582757233017ec10735863489104515ab160c053074905a1eecb7e63": {
    "id": "468b4ab3582757233017ec10735863489104515ab160c053074905a1eecb7e63",
    "name": "D'CENT Wallet",
    "homepage": "https://dcentwallet.com",
    "chains": [
      "eip155:1",
      "eip155:56",
      "eip155:137",
      "eip155:30"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/dcent-hardware-wallet/id1447206611",
      "android": "https://play.google.com/store/apps/details?id=com.kr.iotrust.dcent.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "dcent:",
      "universal": "https://link.dcentwallet.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "D'CENT",
      "colors": {
        "primary": "#fff",
        "secondary": "#fff"
      }
    }
  },
  "29f4a70ad5993f3f73ae8119f0e78ecbae51deec2a021a770225c644935c0f09": {
    "id": "29f4a70ad5993f3f73ae8119f0e78ecbae51deec2a021a770225c644935c0f09",
    "name": "ZelCore",
    "homepage": "https://zel.network",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/zelcore/id1436296839",
      "android": "https://play.google.com/store/apps/details?id=com.zelcash.zelcore",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "zel:",
      "universal": "https://link.zel.network"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "ZelCore",
      "colors": {
        "primary": "rgb(35, 34, 32)",
        "secondary": ""
      }
    }
  },
  "8605171a052e85d629c5efe5db804c7a3fb6d0ecc759d6817f0a18cb3dacbb14": {
    "id": "8605171a052e85d629c5efe5db804c7a3fb6d0ecc759d6817f0a18cb3dacbb14",
    "name": "Nash",
    "homepage": "https://nash.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/nash-app/id1475759236",
      "android": "https://play.google.com/store/apps/details?id=io.nash.app",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "nash:",
      "universal": "https://nash.io/walletconnect"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Nash",
      "colors": {
        "primary": "rgb(0,82,243)",
        "secondary": ""
      }
    }
  },
  "9277bc510b6d95f29be38e7c0e402ae8438262f0f4c6dbb40dfc22f5043e8814": {
    "id": "9277bc510b6d95f29be38e7c0e402ae8438262f0f4c6dbb40dfc22f5043e8814",
    "name": "Coinomi",
    "homepage": "https://coinomi.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/app/coinomi-wallet/id1333588809",
      "android": "https://play.google.com/store/apps/details?id=com.coinomi.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Coinomi",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "6ec1ffc9627c3b9f87676da3f7b5796828a6c016d3253e51e771e6f951cb5702": {
    "id": "6ec1ffc9627c3b9f87676da3f7b5796828a6c016d3253e51e771e6f951cb5702",
    "name": "GridPlus",
    "homepage": "https://gridplus.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "GridPlus",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "a395dbfc92b5519cbd1cc6937a4e79830187daaeb2c6fcdf9b9cce4255f2dcd5": {
    "id": "a395dbfc92b5519cbd1cc6937a4e79830187daaeb2c6fcdf9b9cce4255f2dcd5",
    "name": "CYBAVO Wallet",
    "homepage": "https://cybavo.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/tw/app/cybavo-wallet/id1510697681",
      "android": "https://play.google.com/store/apps/details?id=com.cybavo.btc.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "cybavowallet:",
      "universal": "https://cdn.cybavo.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "CYBAVO",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "c889f5add667a8c69d147d613c7f18a4bd97c2e47c946cabfdd13ec1d596e4a0": {
    "id": "c889f5add667a8c69d147d613c7f18a4bd97c2e47c946cabfdd13ec1d596e4a0",
    "name": "Tokenary",
    "homepage": "https://tokenary.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/tokenary-ethereum-wallet/id1372886601",
      "android": "https://play.google.com/store/apps/details?id=com.jufy.tokenary",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Tokenary",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "3f1bc4a8fd72b3665459ec5c99ee51b424f6beeebe46b45f4a70cf08a84cbc50": {
    "id": "3f1bc4a8fd72b3665459ec5c99ee51b424f6beeebe46b45f4a70cf08a84cbc50",
    "name": "Torus",
    "homepage": "https://toruswallet.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "https://app.tor.us/",
      "ios": "",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Torus",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "7b83869f03dc3848866e0299bc630aaf3213bea95cd6cecfbe149389cf457a09": {
    "id": "7b83869f03dc3848866e0299bc630aaf3213bea95cd6cecfbe149389cf457a09",
    "name": "Spatium",
    "homepage": "https://spatium.net/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/spatium/id1404844195",
      "android": "https://play.google.com/store/apps/details?id=capital.spatium.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Spatium",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150": {
    "id": "0b415a746fb9ee99cce155c2ceca0c6f6061b1dbca2d722b3ba16381d0562150",
    "name": "SafePal",
    "homepage": "https://safepal.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/safepal-wallet/id1548297139",
      "android": "https://play.google.com/store/apps/details?id=io.safepal.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "safepalwallet:",
      "universal": "https://link.safepal.io"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "SafePal",
      "colors": {
        "primary": "rgb(0, 128, 255)",
        "secondary": ""
      }
    }
  },
  "d0387325e894a1c4244820260ad7c78bb20d79eeec2fd59ffe3529223f3f84c6": {
    "id": "d0387325e894a1c4244820260ad7c78bb20d79eeec2fd59ffe3529223f3f84c6",
    "name": "Infinito",
    "homepage": "https://infinitowallet.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/infinito-wallet/id1315572736",
      "android": "https://play.google.com/store/apps/details?id=io.infinito.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Infinito",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "176b83d9268d77438e32aa44770fb37b40d6448740b6a05a97b175323356bd1b": {
    "id": "176b83d9268d77438e32aa44770fb37b40d6448740b6a05a97b175323356bd1b",
    "name": "wallet.io",
    "homepage": "https://wallet.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/vn/app/wallet-io/id1459857368",
      "android": "https://play.google.com/store/apps/details?id=io.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "wallet.io",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "802a2041afdaf4c7e41a2903e98df333c8835897532699ad370f829390c6900f": {
    "id": "802a2041afdaf4c7e41a2903e98df333c8835897532699ad370f829390c6900f",
    "name": "Infinity Wallet",
    "homepage": "https://infinitywallet.io/",
    "chains": [
      "eip155:1",
      "eip155:56",
      "eip155:137"
    ],
    "app": {
      "browser": "",
      "ios": "",
      "android": "",
      "mac": "https://infinitywallet.io/desktop",
      "windows": "https://infinitywallet.io/desktop",
      "linux": "https://infinitywallet.io/desktop"
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "infinity:",
      "universal": "https://infinitywallet.io/"
    },
    "metadata": {
      "shortName": "Infinity",
      "colors": {
        "primary": "#197fe1",
        "secondary": "#fff"
      }
    }
  },
  "8fb830a15679a8537d84c3852e026a4bdb39d0ee3b387411a91e8f6abafdc1ad": {
    "id": "8fb830a15679a8537d84c3852e026a4bdb39d0ee3b387411a91e8f6abafdc1ad",
    "name": "Ownbit",
    "homepage": "https://ownbit.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/es/app/ownbit-btc-eth-cold-wallet/id1321798216",
      "android": "https://play.google.com/store/apps/details?id=com.bitbill.www",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Ownbit",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "244a0d93a45df0d0501a9cb9cdfb4e91aa750cfd4fc88f6e97a54d8455a76f5c": {
    "id": "244a0d93a45df0d0501a9cb9cdfb4e91aa750cfd4fc88f6e97a54d8455a76f5c",
    "name": "EasyPocket",
    "homepage": "https://easypocket.app/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/id1517338927",
      "android": "https://easypocket.app/",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "easypocket:",
      "universal": "https://wallet.easypocket.app"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "EasyPocket",
      "colors": {
        "primary": "rgb(17, 93, 251)",
        "secondary": ""
      }
    }
  },
  "881946407ff22a32ec0e42b2cd31ea5dab52242dc3648d777b511a0440d59efb": {
    "id": "881946407ff22a32ec0e42b2cd31ea5dab52242dc3648d777b511a0440d59efb",
    "name": "Bridge Wallet",
    "homepage": "https://mtpelerin.com/bridge-wallet",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/bridge-wallet/id1481859680",
      "android": "https://play.google.com/store/apps/details?id=com.mtpelerin.bridge",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Bridge",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "3b0e861b3a57e98325b82ab687fe0a712c81366d521ceec49eebc35591f1b5d1": {
    "id": "3b0e861b3a57e98325b82ab687fe0a712c81366d521ceec49eebc35591f1b5d1",
    "name": "SparkPoint",
    "homepage": "https://sparkpoint.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "",
      "android": "https://play.google.com/store/apps/details?id=com.sparkpoint",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "sparkpoint:",
      "universal": "https://sparkpoint.io"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "SparkPoint",
      "colors": {
        "primary": "rgb(20,67,95)",
        "secondary": ""
      }
    }
  },
  "ca86f48760bf5f84dcd6b1daca0fd55e2aa073ecf46453ba8a1db0b2e8e85ac1": {
    "id": "ca86f48760bf5f84dcd6b1daca0fd55e2aa073ecf46453ba8a1db0b2e8e85ac1",
    "name": "ViaWallet",
    "homepage": "https://viawallet.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/us/app/viawallet/id1462031389",
      "android": "https://play.google.com/store/apps/details?id=com.viabtc.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "ViaWallet",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "42d72b6b34411dfacdf5364c027979908f971fc60251a817622b7bdb44a03106": {
    "id": "42d72b6b34411dfacdf5364c027979908f971fc60251a817622b7bdb44a03106",
    "name": "BitKeep",
    "homepage": "https://bitkeep.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/app/bitkeep/id1395301115",
      "android": "https://play.google.com/store/apps/details?id=com.bitkeep.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "bitkeep:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "BitKeep",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "b642ab6de0fe5c7d1e4a2b2821c9c807a81d0f6fd42ee3a75e513ea16e91151c": {
    "id": "b642ab6de0fe5c7d1e4a2b2821c9c807a81d0f6fd42ee3a75e513ea16e91151c",
    "name": "Vision",
    "homepage": "https://vision-crypto.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/id1500186931",
      "android": "https://play.google.com/store/apps/details?id=com.eletac.tronwallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Vision",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "38ee551a01e3c5af9d8a9715768861e4d642e2381a62245083f96672b5646c6b": {
    "id": "38ee551a01e3c5af9d8a9715768861e4d642e2381a62245083f96672b5646c6b",
    "name": "PEAKDEFI Wallet",
    "homepage": "https://peakdefi.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/peakdefi-wallet/id1526193527",
      "android": "https://play.google.com/store/apps/details?id=com.peakdefiwallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "peakdefiwallet:",
      "universal": "https://peakdefi.com/download"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "PEAKDEFI",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "7e90b95230bc462869bbb59f952273d89841e1c76bcc5319898e08c9f34bd4cd": {
    "id": "7e90b95230bc462869bbb59f952273d89841e1c76bcc5319898e08c9f34bd4cd",
    "name": "Unstoppable Wallet",
    "homepage": "https://unstoppable.money/",
    "chains": [
      "eip155:1",
      "eip155:56"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/apple-store/id1447619907",
      "android": "https://play.google.com/store/apps/details?id=io.horizontalsystems.bankwallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "moneyunstoppable:",
      "universal": "https://unstoppable.money"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Unstoppable",
      "colors": {
        "primary": "#FFBE43",
        "secondary": ""
      }
    }
  },
  "025247d02e1972362982f04c96c78e7c02c4b68a9ac2107c26fe2ebb85c317c0": {
    "id": "025247d02e1972362982f04c96c78e7c02c4b68a9ac2107c26fe2ebb85c317c0",
    "name": "HaloDeFi Wallet",
    "homepage": "https://halodefi.org/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "",
      "android": "https://play.google.com/store/apps/details?id=com.halodefi.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "halodefiwallet:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "HaloDeFi",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "d12b6e114af8c47a6eec19a576f1022032a5ee4f8cafee612049f4796c803c7e": {
    "id": "d12b6e114af8c47a6eec19a576f1022032a5ee4f8cafee612049f4796c803c7e",
    "name": "Dok Wallet",
    "homepage": "https://dokwallet.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/il/app/dokwallet-crypto-wallet/id1533065700",
      "android": "https://play.google.com/store/apps/details?id=com.dok.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Dok",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "3d56ed42374504f1bb2ba368094269eaea461c075ab796d504f354baac213dc5": {
    "id": "3d56ed42374504f1bb2ba368094269eaea461c075ab796d504f354baac213dc5",
    "name": "AT.Wallet",
    "homepage": "https://authentrend.com/at-wallet/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/at-wallet/id1479171310",
      "android": "https://play.google.com/store/apps/details?id=com.authentrend.atwallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "AT.Wallet",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "1e04cf5cddcd84edb1370b12eae1fcecedf125b77209fff80e7ef2a6d3c74719": {
    "id": "1e04cf5cddcd84edb1370b12eae1fcecedf125b77209fff80e7ef2a6d3c74719",
    "name": "Midas Wallet",
    "homepage": "https://midasprotocol.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/us/app/midas-protocol-crypto-wallet/id1436698193",
      "android": "https://play.google.com/store/apps/details?id=com.midasprotocol.wallet.android",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Midas",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "15d1d97de89526a3c259a235304a7c510c40cda3331f0f8433da860ecc528bef": {
    "id": "15d1d97de89526a3c259a235304a7c510c40cda3331f0f8433da860ecc528bef",
    "name": "Ellipal",
    "homepage": "https://ellipal.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/ellipal/id1426179665",
      "android": "https://play.google.com/store/apps/details?id=com.ellipal.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "ellipal:",
      "universal": "https://www.ellipal.com/"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Ellipal",
      "colors": {
        "primary": "rgb(48, 124, 249)",
        "secondary": ""
      }
    }
  },
  "0fa0f603076de79bbac9a4d47770186de8913da63c8a4070c500a783cddbd1e3": {
    "id": "0fa0f603076de79bbac9a4d47770186de8913da63c8a4070c500a783cddbd1e3",
    "name": "KEYRING PRO",
    "homepage": "https://keyring.app/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/keyring-pro-wallet-management/id1546824976",
      "android": "https://play.google.com/store/apps/details?id=co.bacoor.keyring",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "keyring:",
      "universal": "https://keyring.app"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "KEYRINGPRO",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "19ad8334f0f034f4176a95722b5746b539b47b37ce17a5abde4755956d05d44c": {
    "id": "19ad8334f0f034f4176a95722b5746b539b47b37ce17a5abde4755956d05d44c",
    "name": "Aktionariat",
    "homepage": "https://aktionariat.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/ch/app/aktionariat/id1518326813",
      "android": "https://play.google.com/store/apps/details?id=com.aktionariat.app",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "aktionariat:",
      "universal": "https://app.aktionariat.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Aktionariat",
      "colors": {
        "primary": "rgb(0, 0, 0)",
        "secondary": ""
      }
    }
  },
  "95501c1a07c8eb575cb28c753ab9044259546ebcefcd3645461086e49b671f5c": {
    "id": "95501c1a07c8eb575cb28c753ab9044259546ebcefcd3645461086e49b671f5c",
    "name": "Talken Wallet",
    "homepage": "https://talken.io",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/talken/id1459475831",
      "android": "https://play.google.com/store/apps/details?id=io.talken.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "talken-wallet:",
      "universal": "https://talken.io"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Talken",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "78640a74036794a5b7f8ea501887c168232723696db4231f54abd3fe524037b4": {
    "id": "78640a74036794a5b7f8ea501887c168232723696db4231f54abd3fe524037b4",
    "name": "XinFin XDC Network",
    "homepage": "https://www.xinfin.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "https://xinfin.network/",
      "ios": "",
      "android": "https://play.google.com/store/apps/details?id=com.xdcwallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "XinFin",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "d612ddb7326d7d64428d035971b82247322a4ffcf126027560502eff4c02bd1c": {
    "id": "d612ddb7326d7d64428d035971b82247322a4ffcf126027560502eff4c02bd1c",
    "name": "Flare Wallet",
    "homepage": "https://flarewallet.io",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/flare-wallet/id1496651406",
      "android": "https://play.google.com/store/apps/details?id=com.flare",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "flare:",
      "universal": "https://flarewallet.io"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Flare",
      "colors": {
        "primary": "rgb(31, 36, 59)",
        "secondary": ""
      }
    }
  },
  "55e5b479c9f49ddac5445c24725857f19888da1ef432ae5e4e01f8054d107670": {
    "id": "55e5b479c9f49ddac5445c24725857f19888da1ef432ae5e4e01f8054d107670",
    "name": "KyberSwap",
    "homepage": "https://kyberswap.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "https://kyberswap.com/",
      "ios": "",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "kyberswap:",
      "universal": "https://kyberswapnew.app.link"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "KyberSwap",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "6193353e17504afc4bb982ee743ab970cd5cf842a35ecc9b7de61c150cf291e0": {
    "id": "6193353e17504afc4bb982ee743ab970cd5cf842a35ecc9b7de61c150cf291e0",
    "name": "AToken Wallet",
    "homepage": "https://atoken.com",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/atoken-app/id1395835245",
      "android": "https://play.google.com/store/apps/details?id=wallet.gem.com.atoken",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "atoken:",
      "universal": "https://www.atoken.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "AToken",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "4e6af4201658b52daad51a279bb363a08b3927e74c0f27abeca3b0110bddf0a9": {
    "id": "4e6af4201658b52daad51a279bb363a08b3927e74c0f27abeca3b0110bddf0a9",
    "name": "Tongue Wallet",
    "homepage": "https://www.tongue.fi",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/fr/app/tongue-wallet-for-defi-degens/id1534705854",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "tongue:",
      "universal": "https://www.tongue.fi"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Tongue",
      "colors": {
        "primary": "rgb(255, 49, 120)",
        "secondary": ""
      }
    }
  },
  "b13fcc7e3500a4580c9a5341ed64c49c17d7f864497881048eb160c089be5346": {
    "id": "b13fcc7e3500a4580c9a5341ed64c49c17d7f864497881048eb160c089be5346",
    "name": "RWallet",
    "homepage": "https://rsk.co/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/rwallet/id1489241342",
      "android": "https://play.google.com/store/apps/details?id=com.rsk.rwallet.reactnative",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "rwallet:",
      "universal": "https://www.rwallet.app"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "RWallet",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "13c6a06b733edf51784f669f508826b2ab0dc80122a8b5d25d84b17d94bbdf70": {
    "id": "13c6a06b733edf51784f669f508826b2ab0dc80122a8b5d25d84b17d94bbdf70",
    "name": "PlasmaPay",
    "homepage": "https://plasmapay.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/id1461735396",
      "android": "https://play.google.com/store/apps/details?id=com.plasmapay.androidapp",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "plasmapay:",
      "universal": "https://plasmapay.com/"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "PlasmaPay",
      "colors": {
        "primary": "rgb(255, 255, 255)",
        "secondary": ""
      }
    }
  },
  "0aafbedfb8eb56dae59ecc37c9a5388509cf9c082635e3f752581cc7128a17c0": {
    "id": "0aafbedfb8eb56dae59ecc37c9a5388509cf9c082635e3f752581cc7128a17c0",
    "name": "O3Wallet",
    "homepage": "https://o3.network",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://itunes.apple.com/app/id1528451572",
      "android": "https://play.google.com/store/apps/details?id=com.o3.o3wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "o3wallet:",
      "universal": "https://o3.network"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "O3Wallet",
      "colors": {
        "primary": "rgb(255,255,255)",
        "secondary": ""
      }
    }
  },
  "761d3d98fd77bdb06e6c90092ee7071c6001e93401d05dcf2b007c1a6c9c222c": {
    "id": "761d3d98fd77bdb06e6c90092ee7071c6001e93401d05dcf2b007c1a6c9c222c",
    "name": "HashKey Me",
    "homepage": "https://me.hashkey.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/hashkey-me/id1547228803",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "hashme:",
      "universal": "https://me.hashkey.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "HashKey Me",
      "colors": {
        "primary": "rgb(254, 142, 63)",
        "secondary": ""
      }
    }
  },
  "0a00cbe128dddd6e096ebb78533a2c16ed409152a377c1f61a6a5ea643a2d950": {
    "id": "0a00cbe128dddd6e096ebb78533a2c16ed409152a377c1f61a6a5ea643a2d950",
    "name": "Jade Wallet",
    "homepage": "https://jadewallet.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/jade-wallet-bitcoin-defi/id1544207492",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Jade",
      "colors": {
        "primary": "#212d66",
        "secondary": ""
      }
    }
  },
  "c04ae532094873c054a6c9339746c39c9ba5839c4d5bb2a1d9db51f9e5e77266": {
    "id": "c04ae532094873c054a6c9339746c39c9ba5839c4d5bb2a1d9db51f9e5e77266",
    "name": "Guarda Wallet",
    "homepage": "https://guarda.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/apple-store/id1442083982?mt=8",
      "android": "https://play.google.com/store/apps/details?id=com.crypto.multiwallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Guarda",
      "colors": {
        "primary": "#fff",
        "secondary": ""
      }
    }
  },
  "ffa139f74d1c8ebbb748cf0166f92d886e8c81b521c2193aa940e00626f4e215": {
    "id": "ffa139f74d1c8ebbb748cf0166f92d886e8c81b521c2193aa940e00626f4e215",
    "name": "Defiant",
    "homepage": "https://defiantapp.tech/",
    "chains": [
      "eip155:1",
      "eip155:42",
      "eip155:30",
      "eip155:31"
    ],
    "app": {
      "browser": "",
      "ios": "",
      "android": "https://play.google.com/store/apps/details?id=ar.com.andinasmart.defiant",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "defiantapp:",
      "universal": "https://defiantapp.tech"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Defiant",
      "colors": {
        "primary": "#274A60",
        "secondary": "#65ef9d"
      }
    }
  },
  "1ce6dae0fea7114846382391d946784d95d9032460a857bb23b55bd9807259d1": {
    "id": "1ce6dae0fea7114846382391d946784d95d9032460a857bb23b55bd9807259d1",
    "name": "Trustee Wallet",
    "homepage": "https://trusteeglobal.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/trustee-wallet-bitcoin-wallet/id1462924276",
      "android": "https://play.google.com/store/apps/details?id=com.trusteewallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Trustee",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "be6607b0a4093c0443bfe9c19ab30c99c91d2638866c99a6a16a71d3c1df78f8": {
    "id": "be6607b0a4093c0443bfe9c19ab30c99c91d2638866c99a6a16a71d3c1df78f8",
    "name": "CoinUs",
    "homepage": "https://coinus.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/apple-store/id1367339746",
      "android": "https://play.google.com/store/apps/details?id=com.theblockchain.coinus.wallet",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "ca151c4caeec5f9cc02ef03e498cb38c02ee5e498a8db13e853315077a5b45dc": {
    "id": "ca151c4caeec5f9cc02ef03e498cb38c02ee5e498a8db13e853315077a5b45dc",
    "name": "cmorq",
    "homepage": "https://cmorq.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/cmorq/id1530022030",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "d01c7758d741b363e637a817a09bcf579feae4db9f5bb16f599fdd1f66e2f974": {
    "id": "d01c7758d741b363e637a817a09bcf579feae4db9f5bb16f599fdd1f66e2f974",
    "name": "Valora",
    "homepage": "https://valoraapp.com",
    "chains": [
      "eip155:42220"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/id1520414263",
      "android": "https://play.google.com/store/apps/details?id=co.clabs.valora",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "celo:",
      "universal": "https://valoraapp.com"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Valora",
      "colors": {
        "primary": "#42D689",
        "secondary": "#FBCC5C"
      }
    }
  },
  "e05615ed22df39c8d9b99ea38b45d4accb103fcef9cfa5d5edd38f5839b5182e": {
    "id": "e05615ed22df39c8d9b99ea38b45d4accb103fcef9cfa5d5edd38f5839b5182e",
    "name": "QuiverX",
    "homepage": "https://quiverx.io",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/quiverx/id1558993212",
      "android": "https://play.google.com/store/apps/details?id=com.quiverx.app",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "36d854b702817e228d5c853c528d7bdb46f4bb041d255f67b82eb47111e5676b": {
    "id": "36d854b702817e228d5c853c528d7bdb46f4bb041d255f67b82eb47111e5676b",
    "name": "Celo Wallet",
    "homepage": "https://celowallet.app/",
    "chains": [
      "eip155:42220"
    ],
    "app": {
      "browser": "https://celowallet.app/",
      "ios": "",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "celowallet:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Celo Wallet",
      "colors": {
        "primary": "#35D07F",
        "secondary": "#FBCC5C"
      }
    }
  },
  "fae2dad4aa2f53339397bb30088bf35a47af16dcaae4a32c0a00b29f843d9da1": {
    "id": "fae2dad4aa2f53339397bb30088bf35a47af16dcaae4a32c0a00b29f843d9da1",
    "name": "Encrypted Ink",
    "homepage": "https://encrypted.ink",
    "chains": [
      "eip155:1",
      "eip155:10",
      "eip155:56",
      "eip155:137",
      "eip155:42161"
    ],
    "app": {
      "browser": "",
      "ios": "",
      "android": "",
      "mac": "https://apps.apple.com/us/app/encrypted-ink/id1572522563",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "encryptedink:",
      "universal": "https://encrypted.ink"
    },
    "metadata": {
      "shortName": "Encrypted Ink",
      "colors": {
        "primary": "#fff",
        "secondary": "#fff"
      }
    }
  },
  "717911f4db0c5eda0e02e76ed179b7940ba1eefffdfb3c9e6540696226860da0": {
    "id": "717911f4db0c5eda0e02e76ed179b7940ba1eefffdfb3c9e6540696226860da0",
    "name": "Elastos Essentials",
    "homepage": "https://elastos.org",
    "chains": [
      "eip155:20",
      "eip155:21"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/elastos-essentials/id1568931743",
      "android": "https://play.google.com/store/apps/details?id=org.elastos.essentials.app",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "essentials:",
      "universal": "https://essentials.elastos.net"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Essentials",
      "colors": {
        "primary": "#000",
        "secondary": "#fff"
      }
    }
  },
  "c20b97dd1679625f4eb0bccd727c80746cb13bd97208b0c8e62c89cfd1d4b9cc": {
    "id": "c20b97dd1679625f4eb0bccd727c80746cb13bd97208b0c8e62c89cfd1d4b9cc",
    "name": "fuse.cash",
    "homepage": "https://fuse.cash/",
    "chains": [
      "eip155:122"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/fuse-cash/id1559937899",
      "android": "https://play.google.com/store/apps/details?id=io.fuse.cash",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "fuse.cash:",
      "universal": "https://app.fuse.cash/"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "fuse.cash",
      "colors": {
        "primary": "#37D888",
        "secondary": "#37D888"
      }
    }
  },
  "9e3f6d07815cfaf1ef7afb089e5c6895b254fced0b84a9ff2b449a631605b5db": {
    "id": "9e3f6d07815cfaf1ef7afb089e5c6895b254fced0b84a9ff2b449a631605b5db",
    "name": "Bitpie",
    "homepage": "https://bitpie.com/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/us/app/bitpie-wallet/id1481314229",
      "android": "https://play.google.com/store/apps/details?id=com.bitpie",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "bitpie:",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Bitpie",
      "colors": {
        "primary": "#ffffff",
        "secondary": "#1a24ff"
      }
    }
  },
  "fbc8d86ad914ebd733fec4812b4b7af5ca709fdd9e75a930115e5baa02c4ef4c": {
    "id": "fbc8d86ad914ebd733fec4812b4b7af5ca709fdd9e75a930115e5baa02c4ef4c",
    "name": "Rabby",
    "homepage": "https://rabby.io/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "https://chrome.google.com/webstore/detail/empty-title/acmacodkjbdgmoleebolmdjonilkdbch",
      "ios": "",
      "android": "",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "",
      "universal": ""
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "",
      "colors": {
        "primary": "",
        "secondary": ""
      }
    }
  },
  "9d6c614d1995741d5313f1f3dbf1f66dcba694de782087d13b8721822502692f": {
    "id": "9d6c614d1995741d5313f1f3dbf1f66dcba694de782087d13b8721822502692f",
    "name": "Stasis",
    "homepage": "https://stasis.net/",
    "chains": [
      "eip155:1"
    ],
    "app": {
      "browser": "",
      "ios": "https://apps.apple.com/app/stasis-wallet/id1371949230",
      "android": "https://play.google.com/store/apps/details?id=com.stasis.stasiswallet&hl=ru&gl=US",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "stasis:",
      "universal": "https://app.stasis.net"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "Stasis",
      "colors": {
        "primary": "#2468E4",
        "secondary": "#FFFFFF"
      }
    }
  },
  "a6ffb821a3c32d36fc9d29e29c2ff79a0cd1db0bca453714777846ddf3fdff76": {
    "id": "a6ffb821a3c32d36fc9d29e29c2ff79a0cd1db0bca453714777846ddf3fdff76",
    "name": "JulWallet",
    "homepage": "https://justliquidity.org/",
    "chains": [
      "eip155:1",
      "eip155:3",
      "eip155:4",
      "eip155:5",
      "eip155:42",
      "eip155:56",
      "eip155:88",
      "eip155:128",
      "eip155:137",
      "eip155:250"
    ],
    "app": {
      "browser": "https://chrome.google.com/webstore/detail/julwallet/fgkldlaelopgncepgpncndebgdddikii?hl=en-US",
      "ios": "https://apps.apple.com/app/julwallet/id1555914591",
      "android": "https://play.google.com/store/apps/details?id=julwallet.com",
      "mac": "",
      "windows": "",
      "linux": ""
    },
    "mobile": {
      "native": "julwallet:",
      "universal": "https://justliquidity.org/"
    },
    "desktop": {
      "native": "",
      "universal": ""
    },
    "metadata": {
      "shortName": "JulWallet",
      "colors": {
        "primary": "#c84ce4",
        "secondary": "#3f00ff"
      }
    }
  }
};
